export default "__VITE_ASSET__CDiYXPIC__"